import createReactComponent from '../createReactComponent';
export default createReactComponent('crop-landscape', 'IconCropLandscape', [
  [
    'path',
    {
      d: 'M4 6m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
]);
